import http from 'hub-http/clients/apiClient';
const ROOT_MIC_ID_PROPERTY = 'hs_root_mic_id';
const SMS_OBJECT_ID = '0-124';
const REQUESTED_PROPERTIES = ['hs_content_id', 'hs_name', 'hs_root_mic_id', 'hs_subscription'];
export function getSmsCrmObject(rootMicId) {
  return http.post('/api/crm-search/search', {
    data: {
      query: '',
      offset: 0,
      count: 1,
      properties: REQUESTED_PROPERTIES,
      filterGroups: [{
        filters: [{
          operator: 'EQ',
          property: ROOT_MIC_ID_PROPERTY,
          value: String(rootMicId)
        }]
      }],
      objectTypeId: SMS_OBJECT_ID,
      requestOptions: {
        allPropertiesFetchMode: 'latest_version',
        includeAllProperties: false
      }
    }
  });
}